export default __webpack_public_path__ + "static/media/Pack_opens.ce091686.mp3";